import { MdiMapLegend } from '../../../../../../assets/icon/iconify';
import { useSelector } from 'react-redux';
import { selectRatesOf1865 } from '../../../../../../features/actuarial/rates-slice';

export default function Legends() {

    const ratesOf1865 = useSelector(selectRatesOf1865);

    return (
        <div className="overflow-hidden rounded-lg border border-gray-200">
            <div className="flex items-center gap-2 border-b border-gray-100 bg-[#186cb2]/10 px-3 py-2">
                <div className="flex h-7 w-7 items-center justify-center rounded-md bg-[#186cb2]/10">
                    <MdiMapLegend width={16} height={16} color="#186cb2" />
                </div>
                <div>
                    <p className="text-xs font-semibold text-gray-700">
                        Plan and Riders
                    </p>
                    <p className="text-[10px] text-gray-500">
                        Available plans and rider acronyms
                    </p>
                </div>
            </div>
            <div className="grid grid-cols-1 gap-2 p-3 sm:grid-cols-2 xl:grid-cols-3">
                {ratesOf1865[0]?.data?.map((rate, index) => (
                    <div key={index} className="flex min-w-0 items-start gap-1.5 rounded-md border border-gray-200 bg-gray-50 px-2 py-1.5 text-xs">
                        <p>
                            <span className="shrink-0 font-semibold text-[#186cb2]">
                            {rate.acronym}{" - "}
                        </span>
                        {rate.name}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    )
}
